import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { isEmpty, range, values } from 'lodash-es';
import { Stack } from '@chakra-ui/react';
import { BIRTHDAY_FORMAT } from '../../constants/birthday';
import { Select } from '../Select';
import { InputLabel } from '../Input/Input';
import { ErrorText } from '../ErrorText';

const MONTH_OPTIONS = range(1, 13);
const MAX_DATE_OPTIONS = range(1, 32);

const Birthday = (props) => {
  const {
    value = {},
    format,
    isInvalid,
    errorMessage,
    label,
    onChange,
    maxYear = dayjs().year(),
  } = props;
  const yearEnalbed = format.includes('YYYY');
  const monthEnalbed = format.includes('MM');
  const dateEnalbed = format.includes('DD');

  const yearOptions = range(1900, maxYear + 1);
  const dateOptions = useMemo(() => {
    if (!value.year || !value.month) {
      return MAX_DATE_OPTIONS;
    }

    const daysInMonth = dayjs(`${value.year}-${value.month}-01`).daysInMonth();
    return range(1, daysInMonth + 1);
  }, [value.year, value.month]);

  const isDateValid = dateOptions.includes(value.date);

  return (
    <>
      <InputLabel label={label} isInvalid={isInvalid} mb="0" />
      <Stack direction="row" gap="15px">
        {yearEnalbed && (
          <Select
            placeholder={value.year ? '' : 'YYYY'}
            isInvalid={isInvalid}
            value={value.year}
            onChange={(e) => onChange({ year: Number(e.target.value) })}
          >
            {yearOptions.map((yearOption) => {
              return (
                <option value={yearOption} key={yearOption}>
                  {yearOption}
                </option>
              );
            })}
          </Select>
        )}
        {monthEnalbed && (
          <Select
            placeholder={value.month ? '' : 'MM'}
            isInvalid={isInvalid}
            value={value.month}
            onChange={(e) => onChange({ month: Number(e.target.value) })}
          >
            {MONTH_OPTIONS.map((monthOption) => {
              return (
                <option value={monthOption} key={monthOption}>
                  {monthOption}
                </option>
              );
            })}
          </Select>
        )}
        {dateEnalbed && (
          <Select
            placeholder={isDateValid ? '' : 'DD'}
            isInvalid={isInvalid}
            value={value.date}
            onChange={(e) => onChange({ date: Number(e.target.value) })}
          >
            {dateOptions.map((dateOption) => {
              return (
                <option value={dateOption} key={dateOption}>
                  {dateOption}
                </option>
              );
            })}
          </Select>
        )}
      </Stack>
      {!isEmpty(errorMessage) && isInvalid && (
        <ErrorText>{errorMessage}</ErrorText>
      )}
    </>
  );
};

Birthday.propTypes = {
  value: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    date: PropTypes.number,
  }).isRequired,
  format: PropTypes.oneOf(values(BIRTHDAY_FORMAT)).isRequired,
  isInvalid: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  maxYear: PropTypes.number,
};

export default Birthday;
